export class DomainError extends Error {
  constructor(
    message: string,
    readonly code:
      | 'INVALID_STATE'
      | 'INVALID_QUANTITY'
      | 'UNIT_MISMATCH'
      | 'STALE_UNDO'
      | 'LIMIT_REACHED'
      | 'NOT_FOUND'
      | 'DUPLICATE_SERIAL'
      | 'STALE_CONTAINER'
      | 'RESTORE_CONFLICT',
  ) {
    super(message);
    this.name = 'DomainError';
  }
}
